// eslint-disable-next-line  @atlassian/tangerine/import/no-parent-imports
import { serveSlackTopReactionInSearchExperiment } from '../../../../../../../common/utils/experiments';

export default {
	get(): boolean {
		return serveSlackTopReactionInSearchExperiment({ fireExperimentExposure: false });
	},
};
